import header from "./header.png"
import head from "./head.png"
import "./styles.css";

export default function Head() {
    return (
        <div className="hero">
            <img src={header} alt="Andres y Mafer 21 de noviembre de 2026" className="header-icon" />
            <div className="hero-overlay">
                <img src={head} alt="AyM" className="head-icon" />
            </div>
        </div>
    );
};